import { Button, ControlGroup, InputGroup, Popover } from "@blueprintjs/core";
import { useMemo } from "react";
import { HexColorPicker, RgbaStringColorPicker } from "react-colorful";
import tinycolor from "tinycolor2";

type ColorInputProps = {
  id?: string;
  value: string;
  disabled?: boolean;
  // Renders an RgbaStringColorPicker instead of HexColorPicker, for fields
  // (e.g. a backdrop color) that need to express alpha — hex cannot.
  alpha?: boolean;
  onValueChange: (value: string) => void;
};

export function ColorInput({
  id,
  value,
  disabled,
  alpha,
  onValueChange,
}: ColorInputProps) {
  const colorButtonIconColor = useMemo<string | undefined>(
    () =>
      (value && tinycolor(value).getBrightness() < 60 && "#ffffff") ||
      undefined,
    [value],
  );

  return (
    <ControlGroup fill>
      <InputGroup
        id={id}
        fill
        disabled={disabled}
        value={value}
        onValueChange={onValueChange}
      />
      <Popover
        position="auto"
        usePortal
        minimal
        canEscapeKeyClose
        disabled={disabled}
        content={
          alpha ? (
            <RgbaStringColorPicker color={value} onChange={onValueChange} />
          ) : (
            <HexColorPicker color={value} onChange={onValueChange} />
          )
        }
      >
        <Button
          disabled={disabled}
          minimal
          outlined
          icon="color-fill"
          style={{
            backgroundColor: value,
            color: colorButtonIconColor,
          }}
        />
      </Popover>
    </ControlGroup>
  );
}
